
import { Component, Vue } from 'vue-property-decorator'
import { ClueService } from '@/services/index'
import { ElForm } from 'element-ui/types/form'

enum EditType {
    edit = 0,
    create = 1
}

enum TITLE_TYPE {
    edit = '设置线索类别',
    create = '创建线索类别'
}

@Component({})
export default class ChannelSort extends Vue {

    private currChannelId = -1
    private isLoading = false
    private pageTotal = 0
    private pageIndex = 1
    private pageSize = 10
    private dialogVisible = false
    private editType = EditType.create
    private channelList: any[] = []
    private dialogTitle = ''
    private channel = {
        title: ''
    }

    get channelRef() {
        return this.$refs.channelRef as ElForm
    }

    private channelRules = {
        title: [
            { validator: this.titleValidator, trigger: 'change' }
        ]
    }

    private async mounted() {
        this.initData()   
    }

    private async initData() {
        this.isLoading = true
        const result = await ClueService.getClueSortList()
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.channelList = result.data
        }
    }

    private async cerateClueSort() {
        const params = { name: this.channel.title }
        this.isLoading = true
        const result = await ClueService.createClueSort(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '创建线索成功',
                showClose: true
            })
            return true
        }
        return false
    }

    private async updateClueSort() {
        const params = {
            id: this.currChannelId,
            name: this.channel.title
        }
        this.isLoading = true
        const result = await ClueService.updateClueSort(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '修改线索成功',
                showClose: true
            })
            return true
        }
        return false
    }

    private onCreateType() {
        this.editType = EditType.create
        this.dialogVisible = true
    }

    private onSetChannel(type: any) {
        this.currChannelId = type.id
        this.editType = EditType.edit
        this.channel.title = type.name
        this.dialogVisible = true
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.initData()
    }

    private onDialogClosed() {
        this.channel.title = ''
        this.channelRef.clearValidate()
    }

    private onDialogOpen() {
        this.dialogTitle = this.editType === 
            EditType.edit ? TITLE_TYPE.edit : TITLE_TYPE.create
    }

    private titleValidator(rule: any, value: string, callback: Function) {
        if (!this.dialogVisible) return
        const length = value.length
        let message = ''
        if (!length) {
            message = '请输入正确的线索类别名称'
        } else if (length < 2) {
            message = '至少2个字符以上'
        } else if (length > 10) {
            message = '名称在10个字符以内'
        }
        message && callback(new Error(message))
        callback()
    }

    private onComfirm() {
        this.channelRef.validate(async (isValid: boolean) => {
            if (isValid) {
                let result = false
                switch (this.editType) {
                    case EditType.edit:
                        result = await this.updateClueSort()
                        break 
                    case EditType.create:
                        result = await this.cerateClueSort()
                        break
                    default:
                        break
                }
                result && this.initData()
                this.dialogVisible = false
            }
        })
    }

}
